<template>
  <button class="switcher">
    <div class="moon" :class="{ active: themeStore.isDark }" @click="themeStore.toggleTheme()">
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.17523 4.00835C9.27317 4.00835 9.33343 3.94055 9.3485 3.85015C9.5745 2.59959 9.56697 2.57699 10.8627 2.33592C10.9607 2.31332 11.0285 2.26059 11.0285 2.15512C11.0285 2.05718 10.9607 1.99691 10.8703 1.97431C9.56697 1.71817 9.59711 1.69557 9.3485 0.467616C9.33343 0.369681 9.27317 0.30188 9.17523 0.30188C9.0773 0.30188 9.01703 0.369681 9.00196 0.460083C8.75336 1.70311 8.79102 1.73324 7.48773 1.97431C7.38979 1.99691 7.32199 2.05718 7.32199 2.15512C7.32199 2.26059 7.38979 2.31332 7.4802 2.33592C8.79102 2.59959 8.77596 2.60713 9.00196 3.85015C9.01703 3.94055 9.0773 4.00835 9.17523 4.00835ZM7.08092 16.5215C9.92105 16.5215 12.2715 15.0449 13.3412 12.5815C13.522 12.1746 13.4618 11.8507 13.2734 11.6699C13.1002 11.4966 12.7988 11.459 12.4598 11.6021C11.8948 11.8356 11.1942 11.9712 10.358 11.9712C7.00559 11.9712 4.86608 9.89954 4.86608 6.62247C4.86608 5.71845 5.04688 4.82197 5.28795 4.30969C5.46122 3.93302 5.44616 3.62415 5.27289 3.42828C5.09208 3.21734 4.76061 3.1646 4.34627 3.33787C1.89789 4.32476 0.232986 6.84848 0.232986 9.74133C0.232986 13.5909 3.06558 16.5215 7.08092 16.5215ZM12.7988 9.20646C12.9495 9.20646 13.0625 9.10099 13.0851 8.93525C13.3262 6.93888 13.4166 6.87861 15.4506 6.5622C15.6314 6.53207 15.7369 6.43413 15.7369 6.2684C15.7369 6.11773 15.6314 6.01226 15.4808 5.98213C13.4241 5.58285 13.3262 5.60545 13.0851 3.60908C13.0625 3.44334 12.9495 3.33787 12.7988 3.33787C12.6406 3.33787 12.5276 3.44334 12.505 3.60155C12.2489 5.63559 12.1811 5.69585 10.1094 5.98213C9.95871 6.00473 9.85324 6.11773 9.85324 6.2684C9.85324 6.4266 9.95871 6.53207 10.1094 6.5622C12.1886 6.96901 12.2414 6.95394 12.505 8.95032C12.5276 9.10099 12.6406 9.20646 12.7988 9.20646ZM7.09599 15.075C3.91686 15.075 1.67942 12.7472 1.67942 9.67353C1.67942 7.91823 2.47043 6.3136 3.74359 5.26644C3.59292 5.70339 3.51005 6.35127 3.51005 6.97655C3.51005 10.796 6.10157 13.3273 10.0114 13.3273C10.5689 13.3273 11.0812 13.2519 11.3524 13.1615C10.4258 14.3518 8.84376 15.075 7.09599 15.075Z" />
      </svg>
    </div>
    <div class="sun" :class="{ active: !themeStore.isDark }" @click="themeStore.toggleTheme()">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.76842 1.01951C9.76842 0.605172 9.41434 0.251099 9 0.251099C8.58566 0.251099 8.23912 0.605172 8.23912 1.01951V2.54881C8.23912 2.96315 8.58566 3.30969 9 3.30969C9.41434 3.30969 9.76842 2.96315 9.76842 2.54881V1.01951ZM12.7818 3.82197C12.488 4.11578 12.488 4.60545 12.7893 4.89926C13.0756 5.19306 13.5728 5.19306 13.8666 4.89172L14.9515 3.8069C15.2453 3.52063 15.2453 3.01589 14.9515 2.72208C14.6576 2.43581 14.168 2.43581 13.8742 2.72961L12.7818 3.82197ZM4.13337 4.89172C4.41964 5.19306 4.91685 5.19306 5.21066 4.89926C5.50447 4.61298 5.50447 4.10824 5.21819 3.82197L4.13337 2.72961C3.8471 2.44334 3.34989 2.43581 3.05608 2.72208C2.76228 3.01589 2.76228 3.52063 3.04855 3.79937L4.13337 4.89172ZM9 4.70339C6.83036 4.70339 5.02986 6.49636 5.02986 8.67353C5.02986 10.8507 6.83036 12.6437 9 12.6437C11.1696 12.6437 12.9626 10.8507 12.9626 8.67353C12.9626 6.49636 11.1696 4.70339 9 4.70339ZM9 6.12721C10.3862 6.12721 11.5463 7.27984 11.5463 8.67353C11.5463 10.0672 10.3862 11.2198 9 11.2198C7.60631 11.2198 6.44615 10.0672 6.44615 8.67353C6.44615 7.27984 7.60631 6.12721 9 6.12721ZM16.6465 9.44195C17.0608 9.44195 17.4074 9.08787 17.4074 8.67353C17.4074 8.25919 17.0608 7.91265 16.6465 7.91265H15.1172C14.7028 7.91265 14.3563 8.25919 14.3563 8.67353C14.3563 9.08787 14.7028 9.44195 15.1172 9.44195H16.6465ZM1.36105 7.91265C0.939176 7.91265 0.592636 8.25919 0.592636 8.67353C0.592636 9.08787 0.939176 9.44195 1.36105 9.44195H2.88281C3.29716 9.44195 3.65123 9.08787 3.65123 8.67353C3.65123 8.25919 3.29716 7.91265 2.88281 7.91265H1.36105ZM13.8591 12.4553C13.5653 12.1615 13.0756 12.1691 12.7818 12.4629C12.488 12.7491 12.488 13.2388 12.7893 13.5402L13.8817 14.625C14.168 14.9188 14.6652 14.9113 14.959 14.6174C15.2453 14.3236 15.2453 13.834 14.9515 13.5402L13.8591 12.4553ZM3.04855 13.5326C2.75475 13.8264 2.74721 14.3236 3.03348 14.6099C3.32729 14.9037 3.83203 14.9113 4.11831 14.625L5.21066 13.5402C5.50447 13.2464 5.50447 12.7491 5.21819 12.4629C4.92439 12.1691 4.42718 12.1691 4.13337 12.4553L3.04855 13.5326ZM9.76842 14.7983C9.76842 14.3839 9.41434 14.0374 9 14.0374C8.58566 14.0374 8.23912 14.3839 8.23912 14.7983V16.3275C8.23912 16.7419 8.58566 17.096 9 17.096C9.41434 17.096 9.76842 16.7419 9.76842 16.3275V14.7983Z" />
      </svg>
    </div>
  </button>
</template>

<script>
import { useThemeStore } from "../stores/themeStore";
import { mapStores } from "pinia";

export default {
  computed: {
    ...mapStores(useThemeStore),
  },
};
</script>

<style scoped>
.switcher {
  background: var(--btn-bg-color);
  width: 80px;
  height: 40px;
  border-radius: 74px;
  border: 1px solid var(--border-color);
  display: flex;
  padding: 0 8px;
  align-items: center;
  justify-content: space-between;
}

.sun,
.moon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: fill var(--transition-time) ease, background-color var(--transition-time) ease;
}

.sun:active,
.moon:active {
  transform: scale(0.8);
}

path {
  transition: fill var(--transition-time) ease;
  width: 18px;
  height: 18px;
  fill: #767676;
}

.sun.active,
.moon.active {
  cursor: default;
  pointer-events: none;
  background-color: var(--switcher-activ-bg);
  transform: scale(1.1);
  transition: fill var(--transition-time) ease;
}

.sun.active svg path,
.moon.active svg path {
  fill: #fff;
  cursor: default;
}

.moon:hover svg path,
.sun:hover svg path {
  fill: #ffffff;
}

@media (max-width:500px) {
  .switcher {
    background: var(--btn-bg-color);
    width: 58px;
    height: 35px;
    border-radius: 74px;
    border: 1px solid var(--border-color);
    display: flex;
    padding: 0 5px;
    align-items: center;
    justify-content: space-between;
  }

  .sun,
  .moon {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: fill var(--transition-time) ease, background-color var(--transition-time) ease;
  }
}
</style>
